export default __webpack_public_path__ + "static/media/p2.b9bcce56.jpg";